import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
// import Button from 'react-bootstrap/Button';
import PKButton from "components/Button/Button";
import { FacebookShareButton, TwitterShareButton, } from 'react-share';
import { Map, GoogleApiWrapper, InfoWindow, Marker } from 'google-maps-react';
// import { CurrentUrl } from 'utils/Helper';
import iconDark from '../../Assets/icon-pin-dark.png';
import iconLight from '../../Assets/icon-pin-red.png';
import { Link } from "react-router-dom";

import EventRegisterButton from 'components/EventRegisterButton/EventRegisterButton';

const mapStyles = {
    width: '100%',
    height: '100%',
};
class MoreEventDetails extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            stores: [],
            showingInfoWindow: false,
            selectedMarkerData: {},
        }
    }

    //  Maps Section method
    displayMarkers = () => {
        return this.props.stores.map((store, index) => {
            const hasNextEvent = !!Object.keys(store.next_event).length;
            return <Marker key={index} id={index} position={{
                lat: store.coordinates_lat,
                lng: store.coordinates_lon,
            }}
                icon={hasNextEvent ? iconDark : iconLight}
                entity_name={store.entity_name}
                friendly_url={store.friendly_url}
                next_event={hasNextEvent ? store.next_event : null}
                onClick={this.onMarkerClick} />
        })
    }


    onMarkerClick = ({ entity_name, friendly_url, next_event }, marker) => {
        this.setState({
            activeMarker: marker,
            showingInfoWindow: true,
            selectedMarkerData: {
                name: entity_name,
                // url: friendly_url,
                ...(next_event && { eventName: next_event.event_name, startTime: next_event.start_time }),
            }
        });
    }


    render() {
        //console.log("RENDER",this.props.event_info);
        const { btnText, eventDetailEventName, price, priceHeading, btnNavigation, eventEndSlot } = this.props;
        const { stores, initialCenter, eventFullDate, google, onInfoWindowClose } = this.props;
        const { activeMarker, showingInfoWindow, selectedMarkerData } = this.state;
        const { eventDetailHeading, showResults, venueHeading, venueDecription, showAndHideEventDetails, venueDubDes, dateHeading } = this.props;
        const { date, time, shareHeading, facebookImg, twitterImg, eventDescription } = this.props;
        
        //let magic_description = eventDescription.replace(/<p>/g,'').replace(/<p\/>/g,'\n').replace(/<br\/>/g,'\n').replace(/[\n]/g,'<br/>');
        
        return (
            <div className="main-section">
                {/* Event Details Section Starts Here */}
                <div className="container">
                    <div className="event-details-section">
                        <div className="event-details-btn-align">
                            <h4>{eventDetailHeading}</h4>
                            <p>{`${eventDetailEventName}`}</p>
                        </div>
                        <div className="d-grid" style={{ display: 'grid' }}>
                            { btnNavigation &&
                            <Link to={`${btnNavigation}`}>

                                <PKButton theme="btn-global btn-green width100 Form_Btn_Pad font-normal marTop5 get-ticket"

                                >
                                    {btnText}
                                </PKButton>
                            </Link>
                            }
                            <PKButton theme="show-hide-btn width100 Form_Btn_Pad font-normal marTop5 get-ticket"
                                OnClickMet={() => showAndHideEventDetails()}>
                                {showResults === true ? "Hide Event Details" : "Show Event Details"}
                            </PKButton>
                        </div>
                    </div>
                    {showResults &&
                        <div>

                            <div className="event-detail-map-section">
                                { this.props.event_info.venue_info &&
                                    <Row>
                                        <Col md={4}>
                                            <div className="all-event-details">
                                                { (!this.props.event_info.venue_info.venue_type || this.props.event_info.venue_info.venue_type === 'physical') &&
                                                <span>
                                                    <h6>{venueHeading}</h6>
                                                    {
                                                        venueDecription || venueDubDes
                                                            ?
                                                            <React.Fragment>
                                                                <p>{venueDecription}</p>
                                                                <p>{venueDubDes}</p>
                                                            </React.Fragment>
                                                            :
                                                            <p>No Venue added</p>
                                                    }
                                                </span>
                                                }
                                                { (this.props.event_info.venue_info.venue_type && this.props.event_info.venue_info.venue_type === 'virtual') &&
                                                <span>
                                                    <h6>Virtual Meeting</h6>
                                                    {
                                                        venueDecription
                                                            ?
                                                            <React.Fragment>
                                                                <p>{venueDecription}</p>
                                                               
                                                            </React.Fragment>
                                                            :
                                                            <p>No Venue added</p>
                                                    }
                                                </span>
                                                }
                                                <span>
                                                    <h6>{dateHeading}</h6>
                                                    <p>{date}</p>
                                                    <p>{`${time} - ${eventEndSlot}`}</p>
                                                </span>
                                                {price &&
                                                    <span>
                                                        <h6>{priceHeading}</h6>
                                                        <p>{price}</p>
                                                    </span>
                                                }
                                                <span>
                                                    <h6>{shareHeading}</h6>
                                                    <span className="d-flex social-btn-align">
                                                        <FacebookShareButton url={window.location.href} quote={eventDetailEventName} className="Demo__some-network__share-button">
                                                            <img src={facebookImg} alt="img" className="img-fluid share-icon facebook-share-icon" />
                                                        </FacebookShareButton>
                                                        <TwitterShareButton url={window.location.href} title={eventDetailEventName} className="Demo__some-network__share-button twitter-icon">
                                                            <img src={twitterImg} alt="img" className="img-fluid share-icon" />
                                                        </TwitterShareButton>
                                                    </span>
                                                </span>
                                            </div>
                                        </Col>
                                        { (!this.props.event_info.venue_info.venue_type || this.props.event_info.venue_info.venue_type === 'physical') &&
                                        <Col md={8}>
                                            <div className="event-location">
                                                <div className="event-map">
                                                    <Map
                                                        className="locationMap"
                                                        google={google}
                                                        zoom={12}
                                                        style={mapStyles}
                                                        center={initialCenter}
                                                        initialCenter={initialCenter}
                                                    >
                                                        {this.displayMarkers(stores)}
                                                        <InfoWindow
                                                            onClose={onInfoWindowClose}
                                                            marker={activeMarker}
                                                            visible={showingInfoWindow}
                                                        >
                                                            <div style={{ padding: '0 10px' }}>
                                                                <a href={selectedMarkerData.url} target="_blank" rel="noopener noreferrer"><h5>{selectedMarkerData.name}</h5></a>
                                                                {selectedMarkerData.comingSoon ? <p>{selectedMarkerData.comingSoon}</p> : null}
                                                                {selectedMarkerData.eventName ? <p>{selectedMarkerData.eventName}</p> : null}
                                                                {eventFullDate ? <p><small>{eventFullDate}</small></p> : null}
                                                            </div>
                                                        </InfoWindow>
                                                    </Map>
    
                                                </div>
                                            </div>
                                        </Col>
                                        }
                                        { (this.props.event_info.venue_info.venue_type && this.props.event_info.venue_info.venue_type === 'virtual') &&
                                        <Col md={8}>
                                            <div className="all-event-details">
                                                <h6>Virtual Meeting Information</h6>
                                                { this.props.event_info.venue_info.virtual_meeting_link &&
                                                    <p>
                                                        Link: <a rel="noopener noreferrer" href={this.props.event_info.venue_info.virtual_meeting_link} target="_blank">
                                                            {this.props.event_info.venue_info.virtual_meeting_link}
                                                        </a>
                                                    </p>
                                                }
                                                { this.props.event_info.venue_info.virtual_meeting_id &&
                                                    <p>
                                                        ID: {this.props.event_info.venue_info.virtual_meeting_id}
                                                    </p>
                                                }
                                                { this.props.event_info.venue_info.virtual_meeting_password &&
                                                    <p>
                                                        Password: {this.props.event_info.venue_info.virtual_meeting_password}
                                                    </p>
                                                }
                                                { this.props.event_info.venue_info.phone &&
                                                    <p>
                                                        Call-in number: {this.props.event_info.venue_info.phone}
                                                    </p>
                                                }


                                            </div>
                                        </Col>
                                        }
                                    </Row>
                                }
                                { !this.props.event_info.venue_info &&
                                    <Row>
                                        <Col md={4}>
                                           <div className="all-event-details">
                                                <span>
                                                    <h6>{dateHeading}</h6>
                                                    <p>{date}</p>
                                                    <p>{`${time} - ${eventEndSlot}`}</p>
                                                </span>
                                                {price &&
                                                    <span>
                                                        <h6>{priceHeading}</h6>
                                                        <p>{price}</p>
                                                    </span>
                                                }
                                                <span>
                                                    <h6>{shareHeading}</h6>
                                                    <span className="d-flex social-btn-align">
                                                        <FacebookShareButton url={window.location.href} quote={eventDetailEventName} className="Demo__some-network__share-button">
                                                            <img src={facebookImg} alt="img" className="img-fluid share-icon facebook-share-icon" />
                                                        </FacebookShareButton>
                                                        <TwitterShareButton url={window.location.href} title={eventDetailEventName} className="Demo__some-network__share-button twitter-icon">
                                                            <img src={twitterImg} alt="img" className="img-fluid share-icon" />
                                                        </TwitterShareButton>
                                                    </span>
                                                </span>
                                            </div>
                                        </Col>
                                        { (this.props.event_info.zoom_webinar_id && this.props.event_info.zoom_webinar_object) &&
                                            <Col md={8}>
                                                <div className="all-event-details">
                                                    <h6>PechaKucha Zoom Webinar</h6>
                                                    { this.props.event_info.end_time < Math.floor(new Date().getTime() / 1000) ?
                                                        <span>Webinar is over</span>
                                                        :
                                                        <React.Fragment>
                                                        { (this.props.event_info.zoom_webinar_id && this.props.zoom_registrant_status !== 'denied') &&
                                                            <EventRegisterButton
                                                                entity_info={{entity_type: 'events', ...this.props.event_info}}
                                                                registered={this.props.zoom_registrant_status ? true : false}
                                                                join_url={this.props.zoom_join_url}
                                                            />
                                                        }
                                                        </React.Fragment>
                                                    }
                                                </div>
                                            </Col>
                                        }
                                        
                                        
                                        { stores.length> 0 &&
                                        <Col md={8}>
                                            
                                                <div className="event-location">
                                                    <div className="event-map">
                                                        <Map
                                                            className="locationMap"
                                                            google={google}
                                                            zoom={12}
                                                            style={mapStyles}
                                                            center={initialCenter}
                                                            initialCenter={initialCenter}
                                                        >
                                                            {this.displayMarkers(stores)}
                                                            <InfoWindow
                                                                onClose={onInfoWindowClose}
                                                                marker={activeMarker}
                                                                visible={showingInfoWindow}
                                                            >
                                                                <div style={{ padding: '0 10px' }}>
                                                                    <a href={selectedMarkerData.url} target="_blank" rel="noopener noreferrer"><h5>{selectedMarkerData.name}</h5></a>
                                                                    {selectedMarkerData.comingSoon ? <p>{selectedMarkerData.comingSoon}</p> : null}
                                                                    {selectedMarkerData.eventName ? <p>{selectedMarkerData.eventName}</p> : null}
                                                                    {eventFullDate ? <p><small>{eventFullDate}</small></p> : null}
                                                                </div>
                                                            </InfoWindow>
                                                        </Map>
        
                                                    </div>
                                                </div>
                                         
                                        </Col>
                                        }
                                    </Row>
                                }
                            </div>
                            <div className="more-event-details">
                                <div className="show-more-description" style={{marginTop:20}}>
                                    <div dangerouslySetInnerHTML={{ __html: eventDescription }} />
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {/* Event Details Section Ends Here */}
            </div>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: 'AIzaSyATS36RdvbWd9ESucCYIVvzqIxj3EFbQcg'
})(MoreEventDetails);
